import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the Subscription module.
 */
export const SUBSCRIPTION_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/subscription/dashboard',
    labelKey: 'Subscription.dashboard',
    icon: '/assets/tablerIcons/outline/layout-dashboard.svg',
    moduleId: 50,
    groupLabelKey: 'MenuRoutes.group.subscriptionOverview'
  },
  {
    path: '/subscription/assets',
    labelKey: 'Subscription.assets',
    icon: '/assets/tablerIcons/outline/list.svg',
    moduleId: 50,
    groupLabelKey: 'MenuRoutes.group.subscriptionOverview'
  },
  {
    path: '/subscription/proposals',
    labelKey: 'Subscription.proposals',
    icon: '/assets/tablerIcons/outline/file-description.svg',
    moduleId: 50,
    groupLabelKey: 'MenuRoutes.group.subscriptionOverview'
  }
];
